import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 18,
	viewBox: "0 0 21 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_9424_23425)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M11.1399 0.632812C10.9535 0.246094 10.5598 0 10.1274 0C9.69495 0 9.30472 0.246094 9.11487 0.632812L6.85433 5.28398L1.80589 6.0293C1.38402 6.09258 1.03245 6.38789 0.902375 6.79219C0.772297 7.19648 0.877766 7.64297 1.18011 7.9418L4.84339 11.5664L3.97855 16.6887C3.90823 17.1105 4.08402 17.5395 4.43206 17.7891C4.78011 18.0387 5.24066 18.0703 5.62034 17.8699L10.1309 15.4617L14.6414 17.8699C15.0211 18.0703 15.4817 18.0422 15.8297 17.7891C16.1778 17.5359 16.3535 17.1105 16.2832 16.6887L15.4149 11.5664L19.0782 7.9418C19.3805 7.64297 19.4895 7.19648 19.3559 6.79219C19.2223 6.38789 18.8743 6.09258 18.4524 6.0293L13.4004 5.28398L11.1399 0.632812Z",
			fill: "#0EAFAF"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9424_23425",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 0H20.25V18H0V0Z",
			fill: "white"
		})
	}) })]
});
export default SvgStar;
